export const pushStorage = {
  firstPaymentKey: (userId: number) => `tp_push_first_payment_${userId}`,
  idvCompletedKey: (userId: number) => `tp_push_idv_completed_${userId}`,
  registeredTokenKey: (userId: number) => `tp_push_registered_token_${userId}`,
  sessionDismissedKey: (userId: number) => `tp_push_dismissed_session_${userId}`,

  /** True only within the current browser session — clears on next login. */
  isDismissedThisSession(userId: number): boolean {
    return sessionStorage.getItem(this.sessionDismissedKey(userId)) === '1';
  },

  setDismissedThisSession(userId: number): void {
    sessionStorage.setItem(this.sessionDismissedKey(userId), '1');
  },

  clearDismissedThisSession(userId: number): void {
    sessionStorage.removeItem(this.sessionDismissedKey(userId));
  },

  hasCompletedIdv(userId: number): boolean {
    return localStorage.getItem(this.idvCompletedKey(userId)) === '1';
  },

  setHasCompletedIdv(userId: number): void {
    localStorage.setItem(this.idvCompletedKey(userId), '1');
  },

  hasMadeFirstPayment(userId: number): boolean {
    return localStorage.getItem(this.firstPaymentKey(userId)) === '1';
  },

  setHasMadeFirstPayment(userId: number): void {
    localStorage.setItem(this.firstPaymentKey(userId), '1');
  },

  getRegisteredToken(userId: number): string | null {
    return localStorage.getItem(this.registeredTokenKey(userId));
  },

  setRegisteredToken(userId: number, token: string): void {
    localStorage.setItem(this.registeredTokenKey(userId), token);
  },

  clearRegisteredToken(userId: number): void {
    localStorage.removeItem(this.registeredTokenKey(userId));
  },
};
